<!-- <li class="panel"> -->
<div class="controparte">
	<div>
		<p class="col-sm-2">
			<button (click)="emitEntity(letteraDiffida)" class="btn btn-primary associa"
				type="submit">Allega</button>
		</p>
		<h4 class="titolo col-sm-3">{{letteraDiffida.tipoLettera.descrizione}}</h4>
		<p class="col-sm-2">
			Data: <strong>{{letteraDiffida.dataLettera ?
				(letteraDiffida.dataLettera | date:'dd/MM/yyyy'): ''}}</strong>
		</p>
		<p class="col-sm-4">
			Mittente: <strong>{{letteraDiffida.mittente}}</strong>
		</p>
		<p class="col-sm-4">
			Destinatario: <strong>{{letteraDiffida.destinatario.nominativo}}</strong>
		</p>
	</div>
</div>
<!-- </li> -->
